/* eslint-disable no-sequences */
export const getJsonFromArray = ([keys, ...values]: [keys: any, values: any]) => 
  values.map(vs => vs.reduce((acc: { [x: string]: any; }, v: any, i: string | number) => (acc[keys[i]] = v, acc), {}))